export const SET_LOGIN = 'SET_LOGIN';
export const SET_LOADING = 'SET_LOADING';


export const SET_SIDEBAR_SHOW = 'SET_SIDEBAR_SHOW';
export const SET_SIDEBAR_UNFOLDABLE = 'SET_SIDEBAR_UNFOLDABLE';